// extracted by mini-css-extract-plugin
module.exports = {"main":"ul_main__Em4wr"};